import { deletePaymentMethod, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function deletePaymentMethodsReducer (state = initState, action) {
  switch (action.type) {
    
    case deletePaymentMethod.DELETE_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case deletePaymentMethod.DELETE_PAYMENT_METHOD_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case deletePaymentMethod.DELETE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
